import config from '../config/Config';

export const isBuilderDomain = () => window.location.hostname.includes('cozmos.world');

export const getMatomoSiteId = (): number => {
  if (isBuilderDomain()) {
    return 41;
  }

  if (config.app_env === 'prod') {
    return 9;
  }

  if (config.app_env === 'test') {
    return 5;
  }

  return 1;
};
